// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__ROfjL","tab":"styles_tab__vlq66","activeTab":"styles_activeTab__10MlG"};